"use client";
import styled from "@emotion/styled";
import { TextPropierties } from "@/types/cssTypes";
import {
  ERROR_COLOR,
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR_HOVER,
  PRIMARY_BUTTON_COLOR_PRESSED,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";
import { getHoverColor } from "@/utils/functions";

export const TextLink = styled("p")<TextPropierties>`
  color: ${SECONDARY_BUTTON_COLOR};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ fontWeight }) => fontWeight};
  letter-spacing: 0.3px;
  cursor: pointer;
  font-weight: 300;
  :hover {
    color: ${PRIMARY_BUTTON_COLOR_HOVER};
  }
  :active {
    color: ${PRIMARY_BUTTON_COLOR_PRESSED};
  }
`;

export const BoldText = styled("p")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 700;
`;

export const BoldTextSpan = styled("span")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 700;
`;

export const SemiBoldText = styled("p")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 500;
`;

export const SemiBoldSpanText = styled("span")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 500;
`;

export const RegularText = styled("p")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 400;
`;

export const LightText = styled("p")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 300;
`;

export const DivLightText = styled("div")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 300;
`;

export const LightTextSpan = styled("span")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 300;
`;

export const SemiBoldFormErrorText = styled("p")`
  color: ${ERROR_COLOR};
  font-size: 12px;
  font-weight: 500;
  margin-bottom: -18px;
`;

export const RegularTextLink = styled(RegularText)`
  cursor: pointer;
  :hover {
    color: ${({ color }) => getHoverColor(color ?? "")} !important;
  }
`;

export const AlmostBoldText = styled("span")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 600;
`;

export const AlmostBoldNewLineText = styled("p")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 600;
`;

export const BlackTextLink = styled("p")<TextPropierties>`
  color: ${NEUTRO_TITLES_COLOR};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ fontWeight }) => fontWeight};
  letter-spacing: 0.3px;
  cursor: pointer;
  font-weight: 300;
  text-decoration: underline;
  :hover {
    color: ${PRIMARY_BUTTON_COLOR_HOVER} !important;
  }
  :active {
    color: ${PRIMARY_BUTTON_COLOR_PRESSED};
  }
`;

export const AlmostBoldPText = styled("p")<TextPropierties>`
  color: ${({ color }) => (color ? color : NEUTRO_TITLES_COLOR)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 600;
`;
